var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconChatHistory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "m-vertical-tabs__icon",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M256,0C114.848,0,0,114.848,0,256v240c0,8.832,7.168,16,16,16h240c141.152,0,256-114.848,256-256S397.152,0,256,0zM272,320H144c-8.832,0-16-7.168-16-16c0-8.832,7.168-16,16-16h128c8.832,0,16,7.168,16,16C288,312.832,280.832,320,272,320zM368,224H144c-8.832,0-16-7.168-16-16c0-8.832,7.168-16,16-16h224c8.832,0,16,7.168,16,16C384,216.832,376.832,224,368,224z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChatHistory);
export default __webpack_public_path__ + "static/media/icon-chat-history.97e75a01b09cadaf366e8cba91fe141d.svg";
export { ForwardRef as ReactComponent };